import axios from "axios";
import config from "../config";

// Create a separate axios instance for audio room API
const audioRoomAxios = axios.create({
  baseURL: config.baseApi,
});

// Add request interceptor to include authorization token
audioRoomAxios.interceptors.request.use((request) => {
  const carMeetStorageString = localStorage.getItem("social-storage");
  const carMeetStorage = JSON.parse(carMeetStorageString);
  
  if (carMeetStorage && carMeetStorage.token) {
    const token = carMeetStorage.token;
    request.headers.Authorization = `Bearer ${token}`;
  }
  
  return request;
});

// Add response interceptor for error handling
audioRoomAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem("social-storage");
        localStorage.clear();
        window.location = "/";
      }
    }
    return Promise.reject(error);
  }
);

const getAudioRoomRequests = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/requests`,
    body
  );

  return response;
};

const manageAudioRoomRequest = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/manage`,
    body
  );

  return response;
};

const getAudioRoomPackages = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/packages/list`,
    body
  );

  return response;
};

const updateAudioRoomPackage = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/packages/update`,
    body
  );

  return response;
};

const createAudioRoomPackage = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/packages/create`,
    body
  );

  return response;
};

const deleteAudioRoomPackage = async (body) => {
  const response = await audioRoomAxios.post(
    `/admin/audio-room/packages/delete`,
    body
  );

  return response;
};

const AudioRoomService = {
  getAudioRoomRequests,
  manageAudioRoomRequest,
  getAudioRoomPackages,
  updateAudioRoomPackage,
  createAudioRoomPackage,
  deleteAudioRoomPackage,
};

export default AudioRoomService;

